import type { ErrorResponse } from '../../shared/types'
import type { PaymentEntity, PaymentReferenceEntity, RefundEntity } from './entities'
import { initContract } from '@ts-rest/core'
import { z } from 'zod'
import { CapturePayment, ChargeConfirmationToken, CreatePaymentRefund, CreatePaymentReference, PaymentRequiredResponseSchema, StripeErrorResponseSchema } from './entities'
import { ReferenceType } from './types'

const c = initContract()

const options = {
  pathPrefix: '/payments',
}

export const paymentPaymentsContract = c.router({
  getPaymentsByReference: {
    method: 'GET',
    path: '/by-reference',
    query: z.object({
      referenceType: z.nativeEnum(ReferenceType),
      referenceId: z.string(),
    }),
    responses: {
      200: c.type<PaymentEntity[]>(),
      400: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  getPayment: {
    method: 'GET',
    path: '/:paymentId',
    pathParams: z.object({
      paymentId: z.string(),
    }),
    responses: {
      200: c.type<PaymentEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  deletePayment: {
    method: 'DELETE',
    path: '/:paymentId',
    pathParams: z.object({
      paymentId: z.string(),
    }),
    responses: {
      200: c.type<PaymentEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  capturePayment: {
    method: 'POST',
    path: '/capture',
    body: CapturePayment,
    responses: {
      201: c.type<PaymentEntity>(),
      404: c.type<ErrorResponse>(),
      409: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
  chargeConfirmationToken: {
    method: 'POST',
    path: '/charge-confirmation-token',
    body: ChargeConfirmationToken,
    responses: {
      201: c.type<PaymentEntity>(),
      402: PaymentRequiredResponseSchema,
      404: c.type<ErrorResponse>(),
      409: c.type<ErrorResponse>(),
      429: StripeErrorResponseSchema,
      500: c.type<ErrorResponse>(),
    },
  },
  createPaymentRefund: {
    method: 'POST',
    path: '/:paymentId/refunds',
    pathParams: z.object({
      paymentId: z.string(),
    }),
    body: CreatePaymentRefund,
    responses: {
      201: c.type<RefundEntity>(),
      400: c.type<ErrorResponse>(),
      404: c.type<ErrorResponse>(),
    },
  },
  createPaymentReference: {
    method: 'POST',
    path: '/:paymentId/references',
    pathParams: z.object({
      paymentId: z.string(),
    }),
    body: CreatePaymentReference,
    responses: {
      201: c.type<PaymentReferenceEntity>(),
      404: c.type<ErrorResponse>(),
      500: c.type<ErrorResponse>(),
    },
  },
}, options)
